import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useUserContext } from '../../context/users/UserContext'
import Logo from "./assets/icon.png"
import AlertComponent from './AlertComponent'
import './NavBar.css'

function Navbar({ title }) {
  const { isAuthenticated, authenticatedUser } = useUserContext()
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // Mantener la lógica de visibilidad si es necesaria
  }, [])

  if (!isAuthenticated || authenticatedUser.pendingPlan || !isVisible) {
    return null
  }

  return (
    <>
      <div className="messages-container">
        <AlertComponent />
      </div>
      <header className="modern-navbar">
        <div className="navbar-container">
          <div className="navbar-content">
            <a href="/" className="navbar-brand">
              <img
                src={Logo}
                alt="Develemos Logo"
                className="navbar-logo"
              />
            </a>
            
            {/* Espacio para futura navegación */}
            <nav className="navbar-navigation">
              {/* Aquí irían los enlaces de navegación cuando se necesiten */}
            </nav>

            <div className="navbar-actions">
              {/* Aquí irían acciones como perfil, notificaciones, etc */}
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

Navbar.defaultProps = {
  title: 'Develemos'
}

Navbar.propTypes = {
  title: PropTypes.string,
}

export default Navbar
